<template>
  <div id="app">
    <div class="page">
      <!-- 添加keep-alive 页面返回 的时候不会刷新页面 -->
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive' />
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive' />
    </div>
    <!-- 底部导航 -->
    <footNav v-if='$route.meta.hasNav' :tabIndex="$route.meta.navIndex"></footNav>
  </div>
</template>

<script>
import footNav from "@/components/common/footNav.vue";
export default {
    name: "app",
    components: {
        footNav
    }
};
</script>

<style lang="less">
body {
    margin: 0;
    font-size: 20px;
}
#app {
    font-size: 14px;
    line-height: 20px;
    // font-family: PingFang SC, sans-serif;
    // -webkit-font-smoothing: antialiased;
    // -moz-osx-font-smoothing: grayscale;
    color: #333;
}
</style>
